import { useTranslation } from 'react-i18next';

import { useConfirmLeavePage } from './useConfirmLeavePage';

type P = {
  readonly message?: string;
  readonly shouldPreventLeaving: boolean;
};

/**
 * Component that prevents the user from leaving the current page if shouldPreventLeaving is true.
 * Displays a confirmation dialog with the provided message when the user tries to navigate away.
 *
 * @example <ConfirmLeavePage shouldPreventLeaving={isDirty} />
 *
 * @param {string} message - The message to be displayed in the confirmation dialog. If not provided, a default message will be used.
 * @param {boolean} shouldPreventLeaving - A boolean indicating whether the user should be prevented from leaving the page.
 * @returns {null} The function does not return any value.
 */
export const ConfirmLeavePage = ({ message, shouldPreventLeaving }: P) => {
  const { t } = useTranslation('common');

  useConfirmLeavePage(
    shouldPreventLeaving,
    message ?? t(($) => $.preventLeavingPage.text),
  );

  return null;
};
